import styled from 'styled-components';
import { P } from 'components/Typography';
import Toggle, { ReadMoreToggle as _ReadMoreToggle } from 'components/Toggle';
import { sizes } from 'style';
import { th } from 'style/theme';
import { InfoText } from '../../styled';

export const Heading = styled.h2`
  margin: 0;
  margin-top: 16px;
  font-size: 20px;
  line-height: 28px;

  @media ${sizes.desktop} {
    margin-top: 24px;
  }
`;

export const Edit = styled.div`
  display: inline-block;
  margin-left: 6px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
`;

export const InfoGroup = styled.div`
  @media ${sizes.desktop} {
    padding: 4px 20px;
    border: 1px solid ${th('colors.pickledBluewood4')};
    border-radius: 24px;
    margin-top: 12px;
  }
`;

export const ApplicantsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
`;

export const DesktopInfoText = styled(InfoText)`
  display: none;

  @media ${sizes.desktop} {
    display: block;
  }
`;

export const StyledToggle = styled(Toggle).attrs({ variant: 'dark' })`
  margin-top: 24px;
  margin-bottom: 24px;
  color: ${th('colors.pickledBluewood')};

  > div {
    font-weight: 500;
  }
`;

export const Reminder = styled(P)`
  text-align: right;
  font-size: 12px;
  font-weight: 700;
  color: ${th('colors.red')};

  @media ${sizes.tabletPortrait} {
    font-size: 14px;
  }
`;
